// src/app/features/hero-report-stepper/hero-report-step1/hero-report-step1.component.ts
import { Component, Input, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormArray,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ItemFormComponent } from '../../hero-report/item-form/item-form.component';

import { Image } from '../../../model/hero-report-image/image.model';

@Component({
  selector: 'app-hero-report-step1',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ItemFormComponent],
  templateUrl: './hero-report-step1.component.html',
})
export class HeroReportStep1Component implements OnInit {
  @Input() formGroup!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    // ensure the image arrays exist
    this.ensureArray('overallImages');
    this.ensureArray('noseImages');
    this.ensureArray('tailImages');
  }

  private ensureArray(name: string) {
    if (!this.formGroup.get(name)) {
      this.formGroup.addControl(name, this.fb.array([]));
    }
  }

  onClassificationSelect(event: any) {
    this.formGroup.patchValue({
      possibleIdentification: event.value,
      evacuationPerimeterM: event.evacuationRadius,
    });
  }

  get overallImages(): Image[] {
    const arr = this.formGroup.get('overallImages') as FormArray;
    return arr.value as Image[];
  }

  get noseImages(): Image[] {
    const arr = this.formGroup.get('noseImages') as FormArray;
    return arr.value as Image[];
  }

  get tailImages(): Image[] {
    const arr = this.formGroup.get('tailImages') as FormArray;
    return arr.value as Image[];
  }

  onItemImageAdd(event: Image) {
    const arr = this.formGroup.get(this.controlName(event.tag)) as FormArray;
    arr.push(this.fb.control(event));
  }

  onItemImageDelete(event: Image) {
    const arr = this.formGroup.get(this.controlName(event.tag)) as FormArray;
    const idx = arr.value.findIndex((img: Image) => img.url === event.url);
    if (idx > -1) {
      arr.removeAt(idx);
    }
  }

  private controlName(
    tag: string
  ): 'overallImages' | 'noseImages' | 'tailImages' {
    switch (tag) {
      case 'OVERALL':
        return 'overallImages';
      case 'NOSE':
        return 'noseImages';
      case 'TAIL':
        return 'tailImages';
      default:
        throw new Error(`Unknown image tag: ${tag}`);
    }
  }
}
